export default __webpack_public_path__ + "static/rendering-patterns-f3e7a23ebaa8dd8dc760bbf6aef8b7e1.png";